module.exports = __webpack_public_path__ + "img/ex-pin-science-exploration.934cf8d4.svg";